export default {
  'pages.login.passwordLogin': '密码登录',
  'pages.login.codeLogin': '短信登录',
  'pages.login.phone': '手机号码',
  'pages.login.phone.placeholder': '请输入手机号',
  'pages.login.phone.valid': '请输入正确的手机号码',
  'pages.login.code': '验证码',
  'pages.login.code.placeholder': '请输入验证码',
  'pages.login.code.valid': '请输入验证码',
  'pages.login.username': '账户',
  'pages.login.username.placeholder': '请输入用户名/手机号',
  'pages.login.username.valid': '请输入用户名/手机号',
  'pages.login.password': '密码',
  'pages.login.password.placeholder': '请输入密码',
  'pages.login.password.valid': '请输入密码',
  'pages.login.register': '立即注册',
  'pages.login.login': '登录',
  'pages.login.sendCode': '获取验证码',
  'pages.login.code.hasSend': '已发送',
  'pages.login.captcha.verification': '验证成功',
  'pages.login.captcha.click': '点此进行验证',
  'pages.login.remember': '保持7天登录',
  'pages.login.authorize.ok': '授权登录',
  'pages.login.authorize.cancel': '拒绝',
  'pages.login.authorize.title': 'Hi! 欢迎来到包材商城',
  'pages.login.authorize.descPrev': '点击授权登录后，您的账户',
  'pages.login.authorize.descNext': '将一键登录包材商城',
  'pages.login.authorize.subDesc':
    '注：（首次激活后，您当前的账户将可以跨创元平台一键登录）',
  'pages.login.loginSuccess': '登录成功',
  'pages.login.sendCode.fail': '验证码发送失败，请重新发送',
  'pages.login.captcha.tip': '请先进行验证',
  'pages.login.password.error': '密码输入不正确',
  'pages.login.code.error': '验证码输入不正确',

  'pages.register.title': '新用户注册',
  'pages.register.companyName': '公司名称',
  'pages.register.companyName.placeholder': '请输入您的公司名称',
  'pages.register.companyName.valid': '请输入您的公司名称',
  'pages.register.contact': '联系人',
  'pages.register.password.valid':
    '密码长度设置8-20位，必须包含数字和字母组合，区分大小写',
  'pages.register.contact.placeholder': '请输入您的姓名',
  'pages.register.contact.valid': '请输入您的姓名',
  'pages.register.hasAccount': '已有账号？',
  'pages.register.readAndAccept': '已阅读并同意',
  'pages.register.term': '条款',
  'pages.register.signUp': '同意条款并注册',
  'pages.register.success': '注册成功',
  'pages.register.fail': '注册失败',
  'pages.register.registerTerm': '用户注册协议',
  'pages.register.secretTerm': '隐私权政策',
  'pages.register.agree': '请先同意条款',
  'pages.register.and': '和',
};
